import { render, staticRenderFns } from "./VideoEmbedded.vue?vue&type=template&id=2527cf94"
import script from "./VideoEmbedded.vue?vue&type=script&lang=js"
export * from "./VideoEmbedded.vue?vue&type=script&lang=js"
import style0 from "./VideoEmbedded.vue?vue&type=style&index=0&id=2527cf94&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports